import React from 'react';
import { AutoFillDoorTypeEnum } from '@inter-ikea-storageone/range-pax/src/api/components/AutofillSingleWallComponent';
import {
  getAllAvailableHingedWidths,
  getAllAvailableSlidingWidths
} from '@inter-ikea-storageone/range-pax/src/api/systems/AutofillSystems/RuleSet/SingleWallRulesSet';
import Select from 'ui/Select/Select';
import Title from 'ui/Typography/Title';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { useIntl } from 'react-intl';
import { adjustMeasurementsSystem } from 'utils/adjustMeasurementsSystem';
import Box from 'ui/Box';
import { isMobile } from 'utils/platform';
import { useTranslations } from 'hooks/useTranslations';
import { useServiceSettings } from 'contexts/serviceSettings';

type Props = {
  onChange: (value: any) => void;
  value: any;
  doorTypeSelection: AutoFillDoorTypeEnum;
};

const AutoFillLOptimizeSpaceSingleWallOptions = ({ onChange, value, doorTypeSelection }: Props) => {
  const { formatMessage } = useIntl();
  const { translations } = useServiceSettings();
  const { unit, useMetric } = useTranslations();
  const singleWallHingedWidths = getAllAvailableHingedWidths();
  const singleWallSlidingWidths = getAllAvailableSlidingWidths();

  const translateValue = (w: string) => {
    return {
      key: `${adjustMeasurementsSystem(Number.parseInt(w), translations, useMetric)} ${unit}`,
      value: w
    };
  };

  return (
    <>
      <Title
        my="md"
        id="autofill-change-door-type-heading"
        type={ThemeFontStyleTypeEnum.headingXSmall}
      >
        {formatMessage({ id: 'storageone.width' })}
      </Title>
      <Box mx={isMobile() ? 'md' : ''}>
        <Select
          id="Autofill_select_door_type"
          items={
            doorTypeSelection === AutoFillDoorTypeEnum.SLIDING
              ? singleWallSlidingWidths.map(w => translateValue(w))
              : singleWallHingedWidths.map(w => translateValue(w))
          }
          onChange={onChange}
          value={value}
          hintText={formatMessage({ id: 'storageone.autofillPaxChooseAnOptionHint' })}
        />
      </Box>
    </>
  );
};

export default AutoFillLOptimizeSpaceSingleWallOptions;
